import { Services } from "../../api/Services";
import { useState } from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CORPORATE_LOGO } from "../../api/Constants";
import { getImageUrl } from 'components/helpers/Helpers';

function ForgotPassword() {
  const [email, setEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const result = await Services.ForgotPasswordd(encodeURIComponent(email));

      if (result.status === 200) {
        toast.success(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.errors[0], {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  return (
    <div className="main-loging">
      <div className="login-wrapper">
        <ToastContainer />
        <div className="home">
          <div className="logo-image">
            <img src={CORPORATE_LOGO} alt="" />
          </div>
          <form onSubmit={handleSubmit}>
            <div className="home-form">
              <div className="form-group">
                <label>Enter your email</label>
                <input
                  type="text"
                  className="form-control input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="login-buttons">
                <button type="submit" className="button">
                  submit
                </button>
                <Link to={"/trainer/"} className="button forgot">
                  Go to Login
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
